import { importExport } from './import-export-de.i18n';

export const de = {
  importExport,
};
